"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InstantSearchSSRProvider = InstantSearchSSRProvider;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _InstantSearchSSRContext = require("../lib/InstantSearchSSRContext");

var _excluded = ["children"];

/**
 * Provider to pass the server state retrieved from `getServerState()` to
 * <InstantSearch>.
 */
function InstantSearchSSRProvider(_ref) {
  var children = _ref.children,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  // When <DynamicWidgets> is mounted, a second provider is used above the user-land
  // <InstantSearchSSRProvider> in `getServerState()`.
  // To avoid the user's provider overriding the context value with an empty object,
  // we skip this provider.
  if (Object.keys(props).length === 0) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
  }

  return /*#__PURE__*/_react.default.createElement(_InstantSearchSSRContext.InstantSearchSSRContext.Provider, {
    value: props
  }, children);
}